module.exports = __webpack_public_path__ + "223f3d289abb22254f36e0434fc03e36.jpg";